<template>
  <el-dialog
    :title="title"
    :visible.sync="isVisible"
    width="900px"
    @close="handleClose"
  >
    <el-form
      :model="packageForm"
      ref="formRef"
      :rules="rules"
      :disabled="isDisabled"
      label-width="120px"
      :inline="false"
    >
      <el-form-item label="套餐类型" prop="mealType">
        <el-radio-group v-model="packageForm.mealType">
          <el-radio :label="1">图片</el-radio>
          <el-radio :label="2">音频</el-radio>
          <el-radio :label="3">视频</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="授权类型" prop="type">
        <el-input v-model="packageForm.type" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="下载完成时间" prop="downloadTime">
        <el-col :span="12">
          <el-input-number
            style="width: 50%;"
            v-model="packageForm.downloadTime"
            :min="1"
            :controls="false"
            :max="99999"
            placeholder="请输入"
          >
          </el-input-number>
        </el-col>
        <el-col :span="11" :offset="1">
          <span>天内下载完成时间</span>
        </el-col>
      </el-form-item>
      <el-form-item label="授权范围" prop="authRange">
        <el-input
          v-model="packageForm.authRange"
          type="textarea"
          placeholder='多种授权请用","隔开'
        ></el-input>
      </el-form-item>
      <el-form-item
        label="套餐产品"
        prop="product"
        style="margin-bottom: 10px;"
      >
        <el-tooltip content="新增" placement="top" effect="dark">
          <i
            v-if="!isDisabled"
            class="el-icon-circle-plus-outline add-icon"
            @click="handleAddProduct"
          ></i>
        </el-tooltip>
      </el-form-item>
      <div class="productTable">
        <el-table :data="packageForm.product" border max-height="280">
          <el-table-column label="数量（张）" prop="count">
            <template slot-scope="scope">
              <el-form-item
                class="marginUnset"
                :prop="`product.${scope.$index}.count`"
                :rules="rules.count"
              >
                <el-input-number
                  v-model="scope.row.count"
                  :min="1"
                  :controls="false"
                  :max="99999"
                  placeholder="请输入"
                ></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="单价（元）" prop="price">
            <template slot-scope="scope">
              <el-form-item
                class="marginUnset"
                :prop="`product.${scope.$index}.price`"
                :rules="rules.price"
              >
                <el-input-number
                  v-model="scope.row.price"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  :max="99999"
                  placeholder="请输入"
                ></el-input-number>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="总价（元）" prop="totalPrice">
            <template slot-scope="scope">
              <div>
                {{ calculateTotalPrice(scope.row.count, scope.row.price) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="operation">
            <template slot-scope="scope">
              <div v-if="packageForm.product.length > 1">
                <el-tooltip content="删除" placement="top" effect="dark">
                  <i
                    class="el-icon-remove-outline del-icon"
                    @click="handleRemoveProduct(scope.row.temp)"
                  >
                  </i>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-form-item label="购买设置" prop="status" class="column-radio">
        <el-radio-group v-model="packageForm.status" direction="vertical">
          <el-radio :label="0">立即购买</el-radio>
          <el-radio :label="1">电话咨询</el-radio>
          <el-radio :label="2">立即咨询</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        :disabled="isDisabled"
        @click="handleSubmit('formRef')"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { addPackage, editPackage } from "@/api/package";
import { watch } from "vue";
export default {
  name: "ManagementSideCreate",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dialogMode: {
      type: String,
      default: "add",
    },
    currentData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    title() {
      return this.dialogMode === "add"
        ? "新增套餐"
        : this.dialogMode === "edit"
        ? "编辑套餐"
        : "详情";
    },
    isDisabled() {
      return this.dialogMode === "detail";
    },
  },
  data() {
    return {
      packageForm: {
        mealType: 1,
        type: "",
        downloadTime: 365,
        authRange: "",
        status: 0,
        product: [
          {
            temp: this.mathRandom(),
            count: undefined,
            price: undefined,
            totalPrice: "",
          },
        ],
      },
      columns: [
        {
          id: 1,
          label: "数量（张）",
          prop: "count",
        },
        {
          id: 2,
          label: "单价（元）",
          prop: "price",
        },
        {
          id: 3,
          label: "总价（元）",
          prop: "totalPrice",
        },
        {
          id: 4,
          label: "操作",
          prop: "operation",
        },
      ],
      rules: {
        type: [
          { required: true, message: "授权类型不能为空", trigger: "blur" },
        ],
        downloadTime: [
          { required: true, message: "下载完成时间不能为空", trigger: "blur" },
        ],
        authRange: [
          { required: true, message: "授权范围不能为空", trigger: "blur" },
        ],
        product: [
          { required: true, message: "套餐产品不能为空", trigger: "blur" },
        ],
        count: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        price: [{ required: true, message: "单价不能为空", trigger: "blur" }],
        status: [
          { required: true, message: "请选择购买设置", trigger: "change" },
        ],
      },
    };
  },

  mounted() {
    this.handleInit();
  },

  methods: {
    handleInit() {
      if (this.dialogMode == "edit" || this.dialogMode == "detail") {
        this.handleEditOrDetail();
      }
    },
    handleClose() {
      this.isVisible = false;
    },
    mathRandom() {
      return String(Math.random())
        .split(".")[1]
        .slice(0, 16);
    },
    handleAddProduct() {
      this.packageForm.product.push({
        temp: this.mathRandom(),
        count: undefined,
        price: undefined,
        totalPrice: "",
      });
    },
    handleRemoveProduct(id) {
      this.packageForm.product = this.packageForm.product.filter(
        (item) => item.temp !== id
      );
    },
    handleEditOrDetail() {
      const {
        mealType,
        type,
        scope,
        downloadTime,
        children,
        status,
      } = this.currentData;
      this.packageForm.mealType = mealType;
      this.packageForm.type = type;
      this.packageForm.downloadTime = downloadTime;
      this.packageForm.authRange = scope;
      this.packageForm.status = status;
      this.packageForm.product = children.map((item) => {
        console.log(item, "item");
        return {
          id: item.id,
          count: item.count,
          price: item.price,
          totalPrice: item.count * item.price,
          menuId: item.menuId,
          temp: item.id,
        };
      });
    },
    handleSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            mealType: this.packageForm.mealType,
            type: this.packageForm.type,
            downloadTime: this.packageForm.downloadTime,
            scope: this.packageForm.authRange,
            children: this.packageForm.product,
            id: this.currentData.id,
            status: this.packageForm.status,
          };
          const api = this.dialogMode === "add" ? addPackage : editPackage;
          const message = this.dialogMode === "add" ? "新增成功" : "编辑成功";
          const reqMethod = this.dialogMode === "add" ? "post" : "put";
          this.$ajax[reqMethod](api, params).then((res) => {
            if (res.data.code === 200) {
              this.$message.success(message);
              this.handleClose();
              this.$emit("refresh");
            }
          });
        }
      });
    },
    calculateTotalPrice(count, price) {
      if (!count || !price) return "";
      const result = Math.round(count * price * 100) / 100;
      return result.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table__row .el-form-item__content {
  margin-left: unset !important;
}
::v-deep .el-input-number {
  width: 100% !important;
}
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
.add-icon,
.del-icon {
  color: black !important;
  cursor: pointer;
  font-size: 20px;
  margin-top: 10px;
}
.productTable {
  margin-left: 120px;
  margin-bottom: 20px;
}
.marginUnset {
  margin-bottom: unset !important;
}
::v-deep .el-table__row .is-error {
  margin-bottom: 22px !important;
}
::v-deep .column-radio .el-radio-group {
  display: flex;
  flex-direction: column;
  .el-radio {
    margin-bottom: 20px;
    &:first-child {
      margin-top: 0px;
    }
    &:last-child {
      margin-bottom: 20px;
    }
  }
}
</style>
